import React, { useEffect, useState } from 'react';
import './Styles.css';
import { InputField, InputFieldAddon, InputFieldWrapper, InputSize } from '@ids/react-input-field';
import { Ui32ArrowSmDown, Ui32ArrowSmUp } from '@ids/react-icons';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';

const SearchableDropdownInput = ({ items, onChange, selectedItem, label, isMandatory = false, placeholder = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    setQuery(selectedItem?.displayNames[0] ?? '');
    setList(items ?? []);
  }, [selectedItem, items]);

  useEffect(() => {
    if (query === selectedItem?.displayNames[0] || query === '') {
      setList(items);
    } else {
      setList(list.filter(item => item.displayNames[0].toLowerCase().includes(query.toLowerCase())));
      setIsOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      <label className="if">{label}</label>
      <InputFieldWrapper
        inputSize={InputSize.SMALL}
        invalid={isMandatory && !selectedItem?.id}
        onClick={() => {
          if (!isOpen) {
            setIsOpen(true);
          }
        }}>
        <InputField
          inputSize={InputSize.MEDIUM}
          placeholder={placeholder}
          onChange={e => {
            setQuery(e.target.value);
          }}
          value={query}
          autoComplete="off"
          invalid={isMandatory && !selectedItem?.id}
        />
        <InputFieldAddon>
          <IconButton
            type={IconButtonType.PLAIN}
            variant={IconButtonVariant.QUIET}
            size={IconButtonSize.X_SMALL}
            onClick={() => {
              if (isOpen) {
                setIsOpen(false);
              }
            }}>
            {isOpen ? <Ui32ArrowSmUp /> : <Ui32ArrowSmDown />}
          </IconButton>
        </InputFieldAddon>
      </InputFieldWrapper>

      {isOpen && (
        <ul className="searchable-dropdown-result-container">
          {list?.map(item => (
            <li
              key={item.id}
              className="searchable-dropdown-result-row-container clickable"
              onClick={() => {
                onChange(item.id);
                setIsOpen(false);
              }}>
              <div className="searchable-dropdown-result-row">
                {item.displayNames.map((name, index) => (
                  <div key={index} className="searchable-dropdown-result-column">
                    {name}
                  </div>
                ))}
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default SearchableDropdownInput;
